export default __webpack_public_path__ + "static/media/banner2.070b2561.png";